import React, { useCallback, useState, useEffect } from 'react'
import { Formik, Field, Form } from 'formik'
import { AddAccountNameSchema } from '../../../schemas/settings'
import InputError from '../../../components/InputError/InputError'
import NeoButton from '../../../components/NeoButton/NeoButton'
import {
  REQUESTS_KEYS,
  SIDENAV_KEYS,
  MENU_SIDEBAR_KEYS,
} from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import NeoInput from '../../../components/NeoInput/NeoInput'
import { carouselCurrentItemSelector, accountsSelector } from '../../../selectors'
import { useDispatch, useSelector } from 'react-redux'
import AccountsService from '../../../services/accounts.service'
import SettingService from '../../../services/settings.service'
import NeoLoader from '../../../components/FormComponents/NeoLoader'

import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import { useHistory } from 'react-router-dom'
import { NeoSuccess } from '../../../components/FormComponents'
import { setAccRefresh } from '../../../actions'

function AccountName() {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const { t } = useTranslation()
  const [accountList, setAccountList] = useState([])
  const accounts = useSelector(accountsSelector) || []
  const [stage, setStage] = useState(1)
  const dispatch = useDispatch()

  useEffect(() => {
    fetchAccounts()
  }, [])

  const fetchAccounts = useCallback(async () => {
    try {
      if (accounts.length === 0) {
        setStage(0)
        const response = await AccountsService.getAllAccounts()
        if (response.status === 200) {
          const casaAccountList = response.data['accountSummaryDetails']
          setAccountList(casaAccountList)
          setStage(1)
        }
      } else {
        if (accounts?.length > 0) {
          setAccountList(accounts)
          setStage(1)
        }
      }
    } catch (err) {
      setStage(1)
    }
  }, [])

  const addNickName = useCallback(async (data, { setSubmitting }) => {
    setLoading(true)
    setSubmitting(true)
    try {
      const response = await SettingService.addAccountNickName({
        accountNumber: data.accountNumber,
        nickName: data.nickName,
      })
      if (response.status === 200) {
        dispatch(setAccRefresh(true))
        setMessage(response.data['message'])
        setSubmitting(false)
        setLoading(false)
        setStage(2)
      }
    } catch (err) {
      setSubmitting(false)
      setLoading(false)
    }
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return <NeoSuccess message={message} linkPath='/accounts' />
      default:
        return renderForm()
    }
  }

  function renderForm() {
    return (
      <Formik
        initialValues={{
          accountNumber: '',
          nickName: '',
        }}
        validationSchema={AddAccountNameSchema}
        onSubmit={addNickName}>
        {({ isSubmitting, errors, touched, handleChange }) => (
          <Form>
            <div className='d-flex row'>
              <div className='col-12'>
                <div className='form-group my-2'>
                  <NeoInput
                    tabIndex='1'
                    mode='select'
                    text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.ACCOUNT_NUMBER)}
                    name='accountNumber'
                    onChange={handleChange}
                    list={accountList}
                    keyValue='accountNo'
                  />
                  <InputError text={errors.accountNumber} touched={touched.accountNumber} />
                </div>
                <div className='form-group my-2'>
                  <NeoInput
                    tabIndex='2'
                    text={t(REQUESTS_KEYS.SELECT_REQUEST_KEYS.SHORT_NAME)}
                    onChange={handleChange}
                    name='nickName'
                    minLength={2}
                    maxLength={20}
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError touched={touched.nickName} text={errors.nickName} />
                </div>
                <div className='mt-5'>
                  {loading ? (
                    <NeoLoader />
                  ) : (
                    <NeoButton
                      tabIndex='3'
                      type='button'
                      mode='newDesign'
                      type='submit'
                      text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.SUBMIT)}
                    />
                  )}
                </div>
                <div className='back-cancel-btn-container'>
                <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'4'} onClick={() => history.goBack()}>
                  {' '}
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='SET_ACCOUNT_NAME'
      keyPath={'SET_ACCOUNT_NAME'}
      showEmptySpace={true}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.ACCOUNT_NAME)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}

export default AccountName
